/**
 * Storage folder names (mapped to Emergent object-storage folder prefixes).
 * Kept for backward compatibility with existing upload call-sites.
 */
export const BUCKETS = {
  AVATARS: 'avatars',
  ARTWORKS: 'artworks',
  ARTIST_ARTWORKS: 'artworks',
  EXHIBITIONS: 'exhibitions',
  EXHIBITION_PAYMENT_PROOFS: 'exhibition-payment-proofs',
  COMMISSION_REFERENCES: 'commission-references',
  COMMISSION_DELIVERIES: 'commission-deliveries',
  COMMISSION_REFS: 'commission-references',
  COMMISSION_WIPS: 'commission-deliveries',
  COMMUNITIES: 'communities',
};

// Supabase has been fully removed; these exports remain as safe no-ops
export const supabase = null;
export const isSupabaseConfigured = false;
